module.exports = __webpack_public_path__ + "img/banks-logo.7a4cb4ed.svg";